import _Message2 from "@ks/kwai-ui/lib/theme-data/message.css";
import "@ks/kwai-ui/lib/theme-data/base.css";
import _Message from "@ks/kwai-ui/lib/message";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
var request = axios.create();
request.interceptors.response.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(response.status === 200)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", Promise.resolve(response.data));
          case 2:
            return _context.abrupt("return", Promise.reject(response));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export default request;
/**
 * res.result !== 1 reject
 */
export function resultCodeCheck(_x2) {
  return _resultCodeCheck.apply(this, arguments);
}
function _resultCodeCheck() {
  _resultCodeCheck = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(res.result === 1)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", res);
          case 2:
            _Message({
              type: 'error',
              message: res.message || '未知错误'
            });
            return _context2.abrupt("return", Promise.reject(res));
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _resultCodeCheck.apply(this, arguments);
}